import React from "react";
import { useSelector } from "react-redux";
import { Wrapper, MessageContainer } from "../../styled";
import SuccessIcon from "../../../Icons/SuccessIcon";
import { message } from "../../../../../store/General/selectors";

const SuccessAlert = () => {
  const resultMessage = useSelector(message);

  return (
    <Wrapper>
      <SuccessIcon />
      <MessageContainer>{resultMessage}</MessageContainer>
    </Wrapper>
  );
};

export default SuccessAlert;
